import { clamp01 } from './progress.js';
export const DEFAULT_TRAFFIC_LIGHT = { red: 0.6, yellow: 0.85 };
/** Avance esperado lineal entre inicio y fin ("YYYY-MM-DD"), para la fecha `on`. */
export function expectedProgress(start, end, on) {
    const s = Date.parse(`${start}T00:00:00Z`);
    const e = Date.parse(`${end}T00:00:00Z`);
    const o = Date.parse(`${on}T00:00:00Z`);
    if (!(e > s))
        return o >= e ? 1 : 0;
    return clamp01((o - s) / (e - s));
}
/** GRAY: todavía no se espera avance (antes de empezar) y no hay datos para juzgar. */
export function trafficLight(actual, expected, t = DEFAULT_TRAFFIC_LIGHT) {
    if (expected <= 0)
        return actual > 0 ? 'GREEN' : 'GRAY';
    const ratio = clamp01(actual) / expected;
    if (ratio < t.red)
        return 'RED';
    if (ratio < t.yellow)
        return 'YELLOW';
    return 'GREEN';
}
//# sourceMappingURL=traffic-light.js.map